import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot } from '@angular/router';
import { AssignmentsService } from 'services/assignments/assignments.service';
import { AssignmentListResponse, AssignmentsListFilters } from 'services/assignments/assignments.interface';
import { Observable } from 'rxjs';

export const assignmentsListResolver: ResolveFn<Observable<AssignmentListResponse>> = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
) => {
  const workflowTypeId = [Number(route.params.workflowTypeId)];
  return inject(AssignmentsService).getAssignmentsList(new AssignmentsListFilters({ workflowTypeId }));
};
